import styled from 'styled-components';
import colors from '../../../../constants/colors';

const Wrapper = styled.main`
  margin: 105px auto;
  width: 990px;
  position: relative,
  z-index: 0;

  @media screen and (max-width: 992px) {
    margin: 0 auto 0;
    width: 100%;
  }
`;

const Section = styled.section`
  background: ${colors.main.white};
  border-radius: 2px;
  position: relative;
  padding-top: 40px;
  padding-bottom: 30px;
  z-index: 0;

  &:not(:last-of-type) {
    margin-bottom: 10px;
  }

  @media screen and (max-width: 992px) {
    ${'' /* overflow: hidden; */}

    &:first-of-type {
      padding-top: 25px;
    }

    &:not(:last-of-type) {
      margin-bottom: 25px;
    }

    &:last-of-type {
      padding-top: 40px;
      padding-bottom: 80px;
    }
  }
`;

export { Wrapper, Section };
